import { BooleanValue, booleanOptions, Option } from 'common/genericOptions';

/**
 * Conversão entre o `Option` usado no state dos formulários e o `boolean`
 * usado no contrato da API.
 *
 * Extraído na SR-1235 a partir das ocorrências do campo `vasosComunicantes`.
 *
 * O comportamento aqui reproduz exatamente o que estava inline nos parsers,
 * incluindo o fallback para `booleanOptions[1]` ("Não"). Outros campos
 * booleanos dos parsers usam fallback diferente ou não usam fallback, por
 * isso NÃO devem ser migrados para cá sem antes ter teste que fixe o
 * comportamento atual de cada um.
 */

/**
 * State (`Option`) → contrato da API (`boolean`).
 *
 * Qualquer valor diferente de `BooleanValue.Yes` resulta em `false`,
 * inclusive `undefined`, `null` e opção com `value` vazio.
 */
export const opcaoParaBoolean = (opcao?: Option | null): boolean => {
  return opcao?.value === BooleanValue.Yes;
};

/**
 * Contrato da API (`boolean`) → state (`Option`).
 *
 * `true` devolve a opção "Sim"; qualquer outro valor devolve "Não",
 * inclusive `undefined` e `null` — o que preserva a retrocompatibilidade
 * com response que não traz o campo.
 */
export const booleanParaOpcao = (valor?: boolean | null): Option => {
  const alvo = valor ? BooleanValue.Yes : BooleanValue.No;
  // O `??` é guard defensivo: booleanOptions sempre contém "Sim" e "Não",
  // então o find não falha no uso real. Mantido e coberto por teste com o
  // módulo isolado. As optional chains do código inline original
  // (`booleanOptions?.find`, `opcao?.value`) foram removidas: booleanOptions é
  // const de módulo e seus itens são literais, nenhum dos dois pode ser nulo.
  return booleanOptions.find((opcao) => opcao.value === alvo) ?? booleanOptions[1];
};
